import React from "react";
import { Navigate } from "react-router-dom";
import { ROUTES_HOME, SESSION_SECURITY_ROLE_KEY } from "../../utils/constants";

const PrivateRoute = ({ children, role }) => {
  const roles = JSON.parse(sessionStorage.getItem(SESSION_SECURITY_ROLE_KEY));
  const hasRole = roles.includes(role);

  return hasRole ? children : <Navigate to={ROUTES_HOME} />;
};

export default PrivateRoute;
